import {Col} from "reactstrap";
import {useState} from "react";

export function InfoPageMessage({message, defaultClosed = true}) {
    const [hidden, setHidden] = useState(defaultClosed);
    return(
        <Col xs={hidden ? 12 : ''}>
            <div className={`${hidden ? 'border border-info-box rounded bg-orange-light d-flex align-items-center cursor-pointer-custom' : 'text-end'}  p-2 mb-2`}>
                <i className={`bx bx-info-circle fs-4  ${hidden ? 'text-info-box' : 'cursor-pointer-custom text-green'}`} onClick={() => setHidden(!hidden)}></i>
                {hidden === true ?
                    /* This: style={{"white-space": "pre-line"}}, is for can use break line (\n) in message variable */
                    <span className='ps-3 text-info-box text-start w-100' style={{"whiteSpace": "pre-line"}} onClick={() => setHidden(!hidden)}>
                        {message}
                    </span>
                : ''}
            </div>
        </Col>
    );
}